import {CMS} from '@holition/face3d'

const clientId = 133
const cms = await CMS.getClient(clientId)

const safariShimEntries = (mapInstance) => {
  const entries = []
  for (const entry of mapInstance) {
    entries.push(entry)
  }
  return entries
}

export const cmsClient = {
  looksMap: () => cms.lookProductMap,
  looks: () => Object.fromEntries(
    safariShimEntries(cms.lookProductMap)
      .map(([k, v]) => [k.id, {name: k.regions[0].meta.name, products: v}])
      .filter(([_, v]) => v.length !== 0)
  ),
  lookById: id => cms.getLookBy({type: 'id', search: id}),
  allProducts: () => [
    ...cms.getProductsByType('foundation'),
    ...cms.getProductsByType('concealer'),
  ],
}
